const BASE = process.env.REACT_APP_API_BASE_URL || ""

const handle = async (response) => {
  const body = await response.json().catch(() => null)
  if (!response.ok) {
    throw new Error(body?.error || `Request failed: ${response.status}`)
  }
  return body
}

// credentials: "include" everywhere — the session cookie lives on
// .occluded.app and these calls must work from any subdomain.

export const listScenes = () =>
  fetch(`${BASE}/api/scenes`, { credentials: "include" }).then(handle)

export const listMyClips = () =>
  fetch(`${BASE}/api/clips`, { credentials: "include" }).then(handle)

export const patchClip = (id, fields) =>
  fetch(`${BASE}/api/clips/${id}`, {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(fields),
  }).then(handle)

export const deleteClip = (id) =>
  fetch(`${BASE}/api/clips/${id}`, {
    method: "DELETE",
    credentials: "include",
  }).then(handle)

/**
 * Upload a clip video with progress. XHR rather than fetch because climbing
 * videos run to hundreds of MB and fetch has no upload-progress events.
 *
 * @param {File} file
 * @param {object} fields {scene, title?, problem_name?, grade?, angle?}
 * @param {(fraction: number) => void} onProgress
 */
export const uploadClip = (file, fields, onProgress) =>
  new Promise((resolve, reject) => {
    const form = new FormData()
    form.append("video", file)
    Object.entries(fields).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") form.append(k, v)
    })
    const xhr = new XMLHttpRequest()
    xhr.open("POST", `${BASE}/api/clips`)
    xhr.withCredentials = true
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total)
    }
    xhr.onload = () => {
      let body = null
      try {
        body = JSON.parse(xhr.responseText)
      } catch (e) {}
      if (xhr.status >= 200 && xhr.status < 300) resolve(body)
      else reject(new Error(body?.error || `Upload failed: ${xhr.status}`))
    }
    xhr.onerror = () => reject(new Error("Upload failed: network error"))
    xhr.send(form)
  })
